module.exports = __webpack_public_path__ + "img/chest-mesomorph-male.97a590fa.svg";